module.exports = __webpack_public_path__ + "img/ic24-info-fill.1340ac63.svg";